(() => {
  if (window.vlsurBuyNowToCartLoaded) {
    return;
  }

  window.vlsurBuyNowToCartLoaded = true;

  const BUTTON_SELECTOR = '[data-buy-now-to-cart]';

  const findProductForm = (button) => {
    return (
      button.closest('form[data-product-form]') ||
      button.closest('form[action*="/cart/add"]')
    );
  };

  const setError = (button, message = '') => {
    const container = button.parentElement;
    const errorElement = container?.querySelector(
      '[data-buy-now-error]'
    );

    if (!errorElement) {
      return;
    }

    errorElement.textContent = message;
    errorElement.hidden = message === '';
  };

  const getResponseMessage = async (response) => {
    try {
      const result = await response.json();

      return (
        result.description ||
        result.message ||
        'No fue posible agregar el producto al carrito.'
      );
    } catch (error) {
      return 'No fue posible agregar el producto al carrito.';
    }
  };

  const addProductAndOpenCart = async (button) => {
    const form = findProductForm(button);

    if (!form) {
      setError(
        button,
        'No se encontró el formulario del producto.'
      );
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const addUrl =
      button.dataset.cartAddUrl || '/cart/add.js';

    const originalText = button.textContent;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Agregando…';

    setError(button);

    try {
      const formData = new FormData(form);

      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(
          await getResponseMessage(response)
        );
      }

      window.location.assign('/cart');
    } catch (error) {
      setError(
        button,
        error.message ||
          'No fue posible agregar el producto al carrito.'
      );

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const button = event.target.closest(
        BUTTON_SELECTOR
      );

      if (!button || button.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      addProductAndOpenCart(button);
    },
    true
  );
})();